<script setup lang="ts">
import type { ShipexkursTab } from '~~/types';
import type { WikiVehicle } from "~~/types/gamedata";

const props = defineProps({
  raw: {
    type: Object as () => WikiVehicle,
    required: true,
  },
});

function formatDate(value: string | null | undefined): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

const tabs = computed<ShipexkursTab[]>(() => {
  const curated = props.raw.curated_data;
  const announced = formatDate(curated?.concept_date);

  return [{
    label: 'Metadaten',
    icon: 'i-lucide-timer',
    items: [
      ...(curated?.added_in_version ? [{
        label: 'Erschienen in Patch',
        value: curated.added_in_version,
      }] : []),
      ...(announced ? [{
        label: 'Angekündigt',
        value: announced,
      }] : []),
      {
        label: 'Aktuelle Version der Daten',
        value: props.raw.version,
      },
      {
        label: 'Quelle der Daten',
        value: 'Star-Citizen.Wiki-API, In-Game-Preise: UEX-Corp',
        full: true
      },
    ],
  }];
});
</script>

<template>
  <ShipexkursShipTable :tabs="tabs" />
</template>
